import Component from '@glimmer/component';

export interface IPriorityFilterDefinitionArgs {}

export default class PriorityFilter extends Component<IFilterArgs<IPriorityFilterDefinitionArgs>> {}
